import { create } from 'zustand';
import { POPOUT_DIRECTION } from '../../hooks';

export const createPopoutDirectionSlice = (set, get) => ({
  popoutDirection: POPOUT_DIRECTION.DEFAULT,
  setPopoutDirection: (popoutDirection) => set({ popoutDirection }),
  detectPopoutDirection: false,
  setDetectPopoutDirection: (detectPopoutDirection) => set({ detectPopoutDirection }),
});
